/**
 * This component is used to close the current tab after a successful login or logout.
 * It is used in the GrandId login and signing flow.
 */
import React, { useEffect } from "react";
import { injectIntl } from "react-intl";

const CloseTab = (props) => {
  const { builder = false, intl } = props;

  useEffect(() => {
    if (builder) {
      return;
    }

    window.close();

    // Fallback for window.close() not working on mobile.
    // Navigates the user back to where the redirect to the IDP originated from.
    const fallback = setTimeout(() => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.replace("/");
      }
    }, 500);

    return () => clearTimeout(fallback);
  }, [builder]);

  return <div>{intl.formatMessage({ id: "CloseTab.text" })}</div>;
};

export default injectIntl(CloseTab);
